<h2 mat-dialog-title>Add user to role</h2>

<mat-dialog-content>
  <form id="form" [formGroup]="form" (ngSubmit)="save()">
    <p>
      <app-form-control-autocomplete
        label="User email"
        (searchString)="userSearch.set($event)"
        [multiple]="true"
        [resource]="userResource"
        [displayWith]="userDisplayWith"
        formControlName="user"
      />
    </p>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button type="submit" form="form" [disabled]="form.pristine || !form.valid">
    Save
  </button>
  <button mat-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>
